'use strict';

export default angular
  .module('maestro.services.data.firmware', [
    'maestro.services.webcore'
  ])
  .service('FirmwareService', FirmwareService)
  .name;

function FirmwareService(webcore, $q, CacheService) {

  /**
   * Get firmware groups.
   * @param organizationId
   * @returns {Promise}
   */
  this.getFirmwareGroups = CacheService.cachePromiseFunc((organizationId) => {
    return $q.when(
      webcore.services.firmware.getFirmwareGroups(organizationId)
        .then(data => $q.resolve(data.groups), err => $q.reject(err))
    );
  });

  /**
   * Update or remove device firmware update groups.
   * @param deviceId
   * @param groupId
   * @returns {Promise}
   */
  this.updateFirmwareGroup = (deviceId, groupId) => {
    let params = {
      deviceId: deviceId
    };

    if (groupId) {
      params.groupId = groupId;
    }
    return $q.when(
      webcore.services.firmware.updateDeviceFirmwareGroup(params)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Get firmware update versions for specified device type.
   * @param deviceType
   * @return {Promise}
   */
  this.getFirmwareVersions = CacheService.cachePromiseFunc((deviceType) => {
    return $q.when(
      webcore.services.firmware.getFirmwareVersions(deviceType)
        .then(data => $q.resolve(data.versions), err => $q.reject(err))
    );
  });

  /**
   * Get firmware update jobs for specified device type.
   * @param deviceType
   * @param groupId
   * @returns {Promise}
   */
  this.getFirmwareUpdateJobs = (deviceType, groupId) => {
    return $q.when(
      webcore.services.firmware.getFirmwareUpdateJobs(deviceType, groupId)
        .then(data => $q.resolve(data.jobs), err => $q.reject(err))
    );
  };

}
